import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatStepper } from '@angular/material/stepper';

import { DeviceDetectorService } from 'ngx-device-detector';

// tslint:disable-next-line:max-line-length
import { PaymentAutomaticConfirmationDialogComponent } from '../payment-automatic-confirmation-dialog/payment-automatic-confirmation-dialog.component';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { UserService } from '../../services/user.service';
import { PaymentService } from '../../services/payment.service';

import { AutoPaymentActionType, AutoPaymentSelected } from '../payment-automatic-note-list/payment-automatic-note-list.component';
import { AutoPaymentDetail, AutoPaymentConfirmationDialogData } from 'src/app/models/payment';

@Component({
  selector: 'app-payment-automatic',
  templateUrl: './payment-automatic.component.html',
  styleUrls: ['./payment-automatic.component.scss']
})
export class PaymentAutomaticComponent implements OnInit {
  @ViewChild('paymentAutomaticStepper', { static: false }) paymentAutomaticStepper: MatStepper;

  private _handleError: HandleError;
  private _logging = environment.logging;
  private _display = environment.display;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  userFullName = '';
  participantIdString = '';
  participantId: number = null;

  step1Complete = false;
  step2Complete = false;
  step1Editable = true;
  step2Editable = true;

  autoPaymentActionType = AutoPaymentActionType;
  autoPaymentSelected: AutoPaymentSelected = {
    autoPaymentActionType: null,
    selectedId: null,
    selectedData: null
  };
  paymentAmount = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _userService: UserService,
    private _paymentService: PaymentService,
    private _deviceService: DeviceDetectorService,
    public paymentConfirmationDialog: MatDialog,
    public media: MediaObserver
  ) {
    this._handleError = _errorHandler.createHandleError('PaymentAutomaticComponent');
    this.userFullName = this._userService.getFullName();
    this.participantId = this._userService.getParticipantId();
    this.participantIdString = this.participantId.toString();
    this.scrollToTop();
  }

  ngOnInit() {}

  onPaymentAutomaticNoteListSelected(autoPaymentSelected: AutoPaymentSelected) {
    if (this._userService.isLoggedIn()) {
      if (
        autoPaymentSelected !== undefined &&
        autoPaymentSelected !== null &&
        autoPaymentSelected.selectedId !== null &&
        autoPaymentSelected.selectedId > 0
      ) {
        this.autoPaymentSelected = autoPaymentSelected;
        this.step1Complete = true;
        setTimeout(() => {
          this.paymentAutomaticStepper.next();
        });
      } else {
        this.autoPaymentSelected = {
          autoPaymentActionType: null,
          selectedId: null,
          selectedData: null
        };
        this.step1Complete = false;
      }
    }
  }

  public onAutoPaymentDataComplete(event: any) {
    // const stepId = this.paymentAutomaticStepper._getStepLabelId(this.paymentAutomaticStepper.selectedIndex);
    const stepId = this.paymentAutomaticStepper._getStepLabelId(0);
    const stepElement = document.getElementById(stepId);
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }, 250);
    }
  }

  onAutoPaymentSetup(autoPaymentDetail: AutoPaymentDetail): void {
    if (this._userService.isLoggedIn()) {
      this.openAutoPaymentConfirmationDialog(autoPaymentDetail);
    }
  }

  onAutoPaymentCanceled(autoPaymentDetail: AutoPaymentDetail): void {
    if (this._userService.isLoggedIn()) {
      this.openAutoPaymentConfirmationDialog(autoPaymentDetail);
    }
  }

  openAutoPaymentConfirmationDialog(autoPaymentDetail: AutoPaymentDetail): void {
    // tslint:disable-next-line:max-line-length
    const autoPaymentConfirmationDialogData: AutoPaymentConfirmationDialogData = this._paymentService.getNewAutoPaymentConfirmationDialogData();
    autoPaymentConfirmationDialogData.dialogTitle =
      (autoPaymentDetail.isAutoPaymentCancel ? ' Cancel ' : '') +
      'Automatic Payment' +
      (autoPaymentDetail.isAutoPaymentSetup ? ' Setup' : '');
    autoPaymentConfirmationDialogData.autoPaymentDetail = autoPaymentDetail;

    if (this._logging.navigationTraceLog) {
      console.log('PaymentAutomaticComponent.openAutoPaymentConfirmationDialog :: Dialog Opened');
    }

    // May need to use screen height as the width if the device browser does not flip the screen width & height on orientation changes
    // const useScreenHeightAsWidth: boolean = window.innerWidth > window.innerHeight && screen.width < screen.height;
    // const screenWidth: number = useScreenHeightAsWidth ? screen.height : this._deviceService.isDesktop() ? window.innerWidth : screen.width;

    // let matDialogConfig: MatDialogConfig;
    // if (screenWidth < this._display.dialogDisplayDialogTriggerWidth) {
    //   matDialogConfig = {
    //     width: '95%',
    //     height: '75%',
    //     disableClose: true,
    //     data: autoPaymentConfirmationDialogData
    //   };
    // } else {
    //   matDialogConfig = {
    //     width: '40%',
    //     disableClose: true,
    //     data: autoPaymentConfirmationDialogData
    //   };
    // }
    const matDialogConfig: MatDialogConfig = {
        width: '95%',
        height: '95%',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        data: autoPaymentConfirmationDialogData
    };

    const dialogRef = this.paymentConfirmationDialog.open(PaymentAutomaticConfirmationDialogComponent, matDialogConfig);

    dialogRef.afterClosed().subscribe(returnData => {
      if (this._logging.navigationTraceLog) {
        console.log('PaymentAutomaticComponent.openAutoPaymentConfirmationDialog :: Dialog Closed');
      }

      const autoPaymentConfirmationDialogDataResponse: AutoPaymentConfirmationDialogData = returnData;
      if (
        autoPaymentConfirmationDialogDataResponse !== undefined &&
        autoPaymentConfirmationDialogDataResponse !== null &&
        autoPaymentConfirmationDialogDataResponse.paymentOk !== undefined &&
        autoPaymentConfirmationDialogDataResponse.paymentOk !== null &&
        autoPaymentConfirmationDialogDataResponse.paymentOk === true
      ) {
        this.step2Complete = true;
        if (this._logging.navigationTraceLog) {
          console.log('PaymentAutomaticComponent.openAutoPaymentConfirmationDialog');
        }
        this._router.navigate(['']);
      } else {
        this.step2Complete = false;
        this._router.navigate(['']);     // 02/05/2021 RA - Navigate back to home screen.
      }
    });
  }

  scrollToTop() {
    const contentStart = document.getElementsByClassName('mat-sidenav-content');
    if (contentStart.length > 0) {
      contentStart[0].scrollTop = 0;
    }
  }
}
